module.exports = __webpack_public_path__ + "media/images/flags/en-516897fd3988e35032b772b026a19f75.svg";